"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ErrorHandler = void 0;
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _nuiLogger = _interopRequireDefault(require("@concur/nui-logger"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var ErrorHandler = exports.ErrorHandler = function ErrorHandler(props) {
  var _props$state = props.state,
    state = _props$state === void 0 ? {} : _props$state,
    _props$mapStateToErro = props.mapStateToError,
    mapStateToError = _props$mapStateToErro === void 0 ? function () {} : _props$mapStateToErro,
    children = props.children;
  (0, _react.useEffect)(function () {
    var prevOnError = window.onerror;
    window.onerror = function (event, fileName, line, col, error) {
      if (prevOnError) {
        prevOnError(event, fileName, line, col, error);
      }
      _nuiLogger.default.error({
        err: error,
        description: "".concat(JSON.stringify({
          event: event,
          fileName: fileName,
          line: line,
          col: col
        })),
        subcategory: 'browser-error',
        nui_data: mapStateToError(state)
      });
    };
  }, []);
  return _react.default.Children.only(children);
};
ErrorHandler.propTypes = {
  mapStateToError: _propTypes.default.func
};
var _default = exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    state: state
  };
})(ErrorHandler);